import ko from "knockout";

export class TranslationTextModel {
    id: KnockoutObservable<string>;
    nl: KnockoutObservable<string>;
    en: KnockoutObservable<string | null>;
    
    currentLanguage: KnockoutObservable<string>;
    isTranslating: KnockoutObservable<boolean>;
    canTranslate: KnockoutComputed<boolean>;
    displayText: KnockoutComputed<string>;
    
    constructor(data: any, currentLanguage: string) {
        this.id = ko.observable(data.id);
        this.nl = ko.observable(data.nl);
        this.en = ko.observable(data.en);
        
        this.currentLanguage = ko.observable(currentLanguage);
        this.isTranslating = ko.observable(false);
        
        this.canTranslate = ko.pureComputed(() => {
            return this.currentLanguage() !== 'nl' && this.en() == null;
        });
        
        this.displayText = ko.pureComputed(() => {
            if (this.currentLanguage() === 'en' && this.en() != null) {
                return this.en()!;
            }
            return this.nl();
        });
    }
    
    async translate() {
        if (!this.canTranslate()) {
            return;
        }
        
        this.isTranslating(true);
        const translatedText = await translateText(this.id(), this.currentLanguage());
        if (translatedText != null) {
            this.en(translatedText);
        }
        this.isTranslating(false);
    }
}

export const translateText = async (translationTextId: string, language: string): Promise<string | null> => {
    const data = {
        translationTextId,
        targetLanguageCode: language
    }
    
    const response = await fetch('/Employee/TranslationText/Translate', {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if (response.ok) {
        const data = await response.text()
        return data;
    }

    return null;
};
